import { z } from 'zod';
export const uploadTypeSchema = z.discriminatedUnion('type', [
    // branding
    z.object({
        type: z.literal('branding/sender_menu_logo'),
        organizationId: z.string(),
    }),
    z.object({
        type: z.literal('branding/sender_menu_icon'),
        organizationId: z.string(),
    }),
    z.object({
        type: z.literal('branding/email_header_logo'),
        organizationId: z.string(),
    }),
    z.object({
        type: z.literal('branding/recipient_header_logo'),
        organizationId: z.string(),
    }),
    z.object({
        type: z.literal('branding/recipient_header_icon'),
        organizationId: z.string(),
    }),
    // user
    z.object({
        type: z.literal('user/avatar'),
        userId: z.string(),
        organizationId: z.string(),
    }),
    // sender
    z.object({
        type: z.literal('sender/task_file'),
        blockClientKey: z.string(),
        taskId: z.string(),
        projectId: z.string(),
        organizationId: z.string(),
    }),
    z.object({
        type: z.literal('sender/task_template_file'),
        blockClientKey: z.string(),
        taskTemplateId: z.string(),
        organizationId: z.string(),
    }),
    z.object({
        type: z.literal('sender/project_template_task_file'),
        blockClientKey: z.string(),
        taskId: z.string(),
        projectTemplateId: z.string(),
        organizationId: z.string(),
    }),
    // recipient
    z.object({
        type: z.literal('recipient/task_file'),
        blockClientKey: z.string(),
        taskId: z.string(),
        projectId: z.string(),
        organizationId: z.string(),
        taskRequestId: z.string(),
    }),
]);
export const uploadTypeSchemaKeys = z.custom((value) => {
    if (uploadTypeSchema._type.type.includes(value)) {
        return { success: true, message: 'Valid upload type' };
    }
    else {
        return { success: false, message: 'Invalid upload type' };
    }
});
//# sourceMappingURL=uploadTypeSchema.js.map